import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class AuthorizeService {

  constructor(private client: HttpClient, private configService: ConfigService) {}

  public authorize(username: string, password: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/auth/login`;

    return this.client.post(url, { username: username, password: password });
  }
}
